import { consoleLogger } from '@shared/logging/consoleLogger';
import { APIMethods } from '@shared/api/utiqAPIMethods';
import { getRevocationPopupScriptPath } from '@shared/getScriptPath';

/**
 * Creates and executes revocation popup script on the page (if doesn't exist), or shows the revocation popup if is already created
 *
 * @returns undefined
 *
 */
export const handleRevocationPopup = () => {
  if (
    document.getElementById('utiq__revocation-popup') &&
    window.Utiq?.API &&
    APIMethods.showRevocationPopupWindow.name in window.Utiq.API
  ) {
    consoleLogger.logDebug(
      'Utiq revocation popup is already loaded on the page. Proceeding...',
    );
    window.Utiq?.API?.showRevocationPopupWindow!();
    return;
  }

  const utiqRevocationPopup = document.createElement('script');
  utiqRevocationPopup.setAttribute('id', 'utiq__revocation-popup');
  utiqRevocationPopup.src = getRevocationPopupScriptPath();
  document.head.appendChild(utiqRevocationPopup);
  consoleLogger.logDebug('Revocation popup appended to the document head');
};
